module.exports = {"410724100":"城关镇","410724101":"照镜镇","410724102":"黄堤镇","410724103":"中和镇","410724104":"徐营镇","410724105":"冯庄镇","410724106":"亢村镇","410724107":"史庄镇","410724108":"太山镇","410724200":"位庄乡","410724203":"大新庄乡","410724400":"原种场","410724401":"园艺场","410724402":"农场","410724560":"西工区管理委员会"}


//////////////////
// WEBPACK FOOTER
// ./src/town/410724.json
// module id = 1708
// module chunks = 0